import Card from "./Card";

function isEmpty(obj) {
    for (const prop in obj) {
        if (Object.hasOwn(obj, prop) && obj[prop].length) {
            return false;
        }
    }
    return true;
}

export default function GalleryCards({ nfts, activeFilters, setCardsListed, search = "" }) {
    let filtredNfts;
    if (search) {
        filtredNfts = nfts.filter((nft) => {
            return nft.name.includes(search)
        })
    } else {
        filtredNfts = nfts.filter((nft) => {
            if (isEmpty(activeFilters)) {
                return true;
            }
            const nftAttributesMap = {};
            for (const attribute of nft.attributes) {
                nftAttributesMap[attribute.trait_type] = attribute.value;
            }
            for (const activeFilter in activeFilters) {
                if (activeFilters[activeFilter].length && (!nftAttributesMap[activeFilter] || activeFilters[activeFilter].findIndex((filter) => filter === nftAttributesMap[activeFilter]) === -1)) {
                    return false;
                }
            }
            return true;
        })
    }
    const render = filtredNfts.map((nft) => <Card nft={nft} />)
    setCardsListed(render.length)
    return (
        <div className="flex flex-wrap lg:justify-start md:justify-evenly sm:justify-center justify-start gap-[16px] md:pl-[0px] pl-[14px] sm:pl-[0px] md:gap-[20px] lg:gap-[21px] ll:w-full md:pr-[16px] lg:pr-[8px] ll:pr-[10px] ">
            {render}
        </div>

    )
}